var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5203_239963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6621 6.94064L7.28945 9.82757C5.62375 10.1213 4.51153 11.7097 4.80524 13.3754L6.78051 24.5777C7.07422 26.2434 8.66263 27.3556 10.3283 27.0619L26.701 24.175C28.3666 23.8813 29.4789 22.2929 29.1852 20.6272L27.2099 9.42484C26.9162 7.75915 25.3278 6.64693 23.6621 6.94064Z",
    stroke: "#242424",
    strokeWidth: 1.75002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 15.5312L27.5921 11.5807M10.5217 20.5881L13.1069 20.1323L13.2968 21.2094L10.7116 21.6653L10.5217 20.5881Z",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5203_239963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.0003,
    height: 28.0003,
    fill: "white",
    transform: "translate(0.78125 5.64453) rotate(-10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.dd5b659773a865ebae882311e4e8ff16.svg";
export { ForwardRef as ReactComponent };